import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import { Button, Input, Form, Card, message, Row, Col } from 'antd';
import { UserOutlined, LockOutlined, UserAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import winpadelLogo from '../../assets/winpadel.png';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const { login } = useContext(LoginContext);

  const handleAlumnoLogin = () => {
    // Redirigir a Auth0 para login de alumnos
    const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const auth0RedirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin;
    
    if (!auth0Domain || !auth0ClientId) {
      message.error('Auth0 no está configurado. Por favor, configure las variables de entorno REACT_APP_AUTH0_DOMAIN y REACT_APP_AUTH0_CLIENT_ID');
      return;
    }

    // IMPORTANTE: Usamos http://localhost:3001 como redirect_uri (sin hash)
    // Auth0 redirigirá a esta URL con ?code=xxx
    // Luego el archivo index.html o una ruta especial manejará la redirección
    // En Auth0 Dashboard, asegúrate de tener: http://localhost:3001 en "Allowed Callback URLs"
    const redirectUri = auth0RedirectUri; // http://localhost:3001 (sin /auth0-callback.html)
    
    console.log('🔍 Redirect URI para Auth0:', redirectUri);
    console.log('🔍 Asegúrate de que esta URL esté en "Allowed Callback URLs" en Auth0 Dashboard');
    
    const auth0Url = `https://${auth0Domain}/authorize?` +
      `client_id=${auth0ClientId}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `response_type=code&` +
      `scope=openid profile email&` +
      `audience=${encodeURIComponent(process.env.REACT_APP_AUTH0_AUDIENCE || '')}`;
    
    console.log('🔍 URL de Auth0 completa:', auth0Url);
    window.location.href = auth0Url;
  };

  const handleAdminSubmit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'http://localhost:3000/api'}/usuarios/login`,
        { user: credentials.user, password: credentials.password },
        { withCredentials: true }
      );

      const { usuario, token, refreshToken } = response.data;

      // Guardar refreshToken en localStorage (igual que en Auth0)
      if (refreshToken) {
        try {
          localStorage.setItem('refreshToken', refreshToken);
          console.log('✅ RefreshToken guardado en localStorage');
        } catch (err) {
          console.warn('⚠️ No se pudo guardar refreshToken:', err);
        }
      }

      login({ ...usuario, token, refreshToken });
      // Marcar que acabamos de hacer login para evitar que el contexto haga logout
      sessionStorage.setItem('justLoggedIn', 'true');
      // Redirigir según rol
      const rol = (usuario.tiu_descripcion || (usuario.usu_tipousuario === 4 ? 'FICHADA' : '')).toUpperCase();
      if (!['ADMINISTRADOR', 'PROFESOR', 'FICHADA'].includes(rol)) {
        message.error('Este acceso es solo para administradores, profesores y terminal de fichada');
        return;
      }
      const destinos = {
        ADMINISTRADOR: '/#/home-administrador',
        PROFESOR: '/#/agenda-calendario',
        FICHADA: '/#/terminal-fichada',
      };
      const destino = destinos[rol] || '/#/login';
      setTimeout(() => {
        window.location.href = destino;
      }, 100);
    } catch (error) {
      message.error('Credenciales incorrectas');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'flex-start', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: '#1a1a1a',
      padding: window.innerWidth <= 768 ? '12px' : '20px',
      paddingTop: window.innerWidth <= 768 ? '40px' : '60px',
      paddingBottom: window.innerWidth <= 768 ? '12px' : '20px',
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: '100vw',
      overflowX: 'hidden'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '800px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'flex-start',
        boxSizing: 'border-box'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img 
            src={winpadelLogo} 
            alt="WinPadel" 
            style={{ 
              maxWidth: '250px', 
              height: 'auto', 
              marginBottom: '20px',
              display: 'block',
              margin: '0 auto 20px auto'
            }} 
          />
        </div>

        {!showAdminLogin ? (
          <>
            <Row gutter={[24, 24]} justify="center">
              <Col xs={24} sm={12} md={12}>
                <Card
                  hoverable
                  onClick={handleAlumnoLogin}
                  style={{
                    background: '#2d2d2d',
                    borderColor: '#404040',
                    cursor: 'pointer',
                    height: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s',
                  }}
                  bodyStyle={{
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px'
                  }}
                >
                  <UserOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
                  <h2 style={{ color: '#e0e0e0', marginBottom: '8px' }}>Ingreso Alumno</h2>
                  <p style={{ color: '#b0b0b0', margin: 0 }}>
                    Inicia sesión con tu cuenta de Auth0
                  </p>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Card
                  hoverable
                  onClick={() => setShowAdminLogin(true)}
                  style={{
                    background: '#2d2d2d',
                    borderColor: '#404040',
                    cursor: 'pointer',
                    height: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s',
                  }}
                  bodyStyle={{
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px'
                  }}
                >
                  <LockOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
                  <h2 style={{ color: '#e0e0e0', marginBottom: '8px' }}>Ingreso Administrador</h2>
                  <p style={{ color: '#b0b0b0', margin: 0 }}>
                    Acceso para administradores, profesores y terminal de fichada
                  </p>
                </Card>
              </Col>
            </Row>
            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <Link to="/registro-alumno">
                <Button 
                  type="link" 
                  icon={<UserAddOutlined />}
                  style={{ 
                    color: '#b0b0b0',
                    fontSize: '14px',
                    padding: '8px 16px'
                  }}
                >
                  ¿Eres nuevo? Solicita tu registro aquí
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <Card 
            style={{ 
              width: '100%', 
              maxWidth: '400px', 
              margin: '0 auto', 
              background: '#2d2d2d', 
              borderColor: '#404040' 
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <LockOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px' }} />
              <h2 style={{ color: '#e0e0e0', marginBottom: '8px' }}>Ingreso Administrador</h2>
            </div>
            <Form onFinish={handleAdminSubmit}>
              <Form.Item>
                <Input
                  placeholder="Usuario"
                  value={credentials.user}
                  onChange={(e) => setCredentials({ ...credentials, user: e.target.value })}
                />
              </Form.Item>
              <Form.Item>
                <Input.Password
                  placeholder="Contraseña"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Iniciar sesión
                </Button>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                <Button 
                  type="link" 
                  onClick={() => setShowAdminLogin(false)}
                  style={{ padding: 0, color: '#b0b0b0' }}
                >
                  ← Volver a selección
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
        
        {/* Footer */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: 'auto',
          paddingTop: '40px',
          paddingBottom: '20px',
          color: '#b0b0b0',
          fontSize: '14px'
        }}>
          <a 
            href="https://genosoft.com.ar/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#b0b0b0',
              textDecoration: 'none',
              transition: 'color 0.3s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#e0e0e0'}
            onMouseLeave={(e) => e.target.style.color = '#b0b0b0'}
          >
            Desarrollado por Geno Software
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;

